/*!
 * Copyright (c) 2020-2021 Digital Bazaar, Inc. All rights reserved.
 */
import suiteContext from 'ed25519-signature-2020-context';

export {Ed25519Signature2020} from './Ed25519Signature2020.js';
export {suiteContext};
